import SecurityIPSetting from '../../../ts/components/tenant/SecurityIPSetting';
import translations from '../../translations';
import type { SecuritySettingsAPI } from '../../types/Tenant';
import FormGroup from '../generic/FormGroup';
import Toggle from '../inputs/Toggle';
import type { UpdateTenant } from './TenantPage';

type SecurityProps = {
    securitySettings: SecuritySettingsAPI | null;
    updateTenant: UpdateTenant;
    requirePublicFlowPublishConfirmation: boolean;
};

const Security = ({
    securitySettings,
    updateTenant,
    requirePublicFlowPublishConfirmation,
}: SecurityProps) => {
    const isRunRestrictedByIPRange = securitySettings?.isRunRestrictedByIPRange ?? false;
    const isDrawRestrictedByIPRange = securitySettings?.isDrawRestrictedByIPRange ?? false;
    const isAdminRestrictedByIPRange = securitySettings?.isAdminRestrictedByIPRange ?? false;
    const isPackagingRestrictedByIPRange =
        securitySettings?.isPackagingRestrictedByIPRange ?? false;
    const authorizedAdminIPRanges = securitySettings?.authorizedAdminIPRanges ?? [];
    const authorizedDrawIPRanges = securitySettings?.authorizedDrawIPRanges ?? [];
    const authorizedPackagingIPRanges = securitySettings?.authorizedPackagingIPRanges ?? [];
    const authorizedRunIPRanges = securitySettings?.authorizedRunIPRanges ?? [];

    return (
        <div className="form-group">
            <FormGroup>
                <label htmlFor="publish-confirmation">
                    <Toggle
                        id="publish-confirmation"
                        testId="publishConfirmation"
                        isOn={requirePublicFlowPublishConfirmation}
                        onChange={({ isOn }) =>
                            updateTenant({
                                tenantSettings: { requirePublicFlowPublishConfirmation: isOn },
                            })
                        }
                    />
                    {translations.TENANT_security_publish_confirmation_toggle_label}
                </label>
            </FormGroup>

            <p>{translations.TENANT_security_description}</p>

            <SecurityIPSetting
                ipRange="authorizedRunIPRanges"
                isActive={isRunRestrictedByIPRange}
                settingPropertyName="isRunRestrictedByIPRange"
                rangeEntries={authorizedRunIPRanges}
                labelText={translations.TENANT_security_ip_setting_run_restrictions_label}
                updateTenant={updateTenant}
            />
            <SecurityIPSetting
                ipRange="authorizedDrawIPRanges"
                isActive={isDrawRestrictedByIPRange}
                settingPropertyName="isDrawRestrictedByIPRange"
                rangeEntries={authorizedDrawIPRanges}
                labelText={translations.TENANT_security_ip_setting_draw_restrictions_label}
                updateTenant={updateTenant}
            />
            <SecurityIPSetting
                ipRange="authorizedAdminIPRanges"
                isActive={isAdminRestrictedByIPRange}
                settingPropertyName="isAdminRestrictedByIPRange"
                rangeEntries={authorizedAdminIPRanges}
                labelText={translations.TENANT_security_ip_setting_admin_restrictions_label}
                updateTenant={updateTenant}
            />
            <SecurityIPSetting
                ipRange="authorizedPackagingIPRanges"
                isActive={isPackagingRestrictedByIPRange}
                settingPropertyName="isPackagingRestrictedByIPRange"
                rangeEntries={authorizedPackagingIPRanges}
                labelText={translations.TENANT_security_ip_setting_package_restrictions_label}
                updateTenant={updateTenant}
            />
        </div>
    );
};

export default Security;
